<template>
  <div
    :id="id"
    class="modal fade"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <ValidationObserver
          v-slot="{ invalid }"
          :disabled="true"
        >
          <div class="modal-header">
            <modal-close-button @confirmed="closeModal" />
            <h4 class="modal-title">{{ getModalTitle() }}</h4>
          </div>
          <div class="modal-body">
            <div class="col-xl-12 pr-4">
              <!-- START Stammdaten -->
              <container-headline
                :headline="$t('global.masterdata')"
                :col="6"
              ></container-headline>
              <div class="row mb-3">
                <div class="col-xl-12 block br-t-l-0">
                  <div class="eingabe-panel-kopf p-3">
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-radio-group">
                          <div class="form-checkbox">
                            <input
                              type="checkbox"
                              class="mr-2"
                              v-model="infoscreen"
                            />
                            {{ $t('global.showoninfoscreen') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <ValidationProvider
                            rules="required"
                            immediate
                            v-slot="{ passed }"
                          >
                            <input
                              v-model.trim="bezeichnung"
                              class="form-control"
                              v-bind:class="{ 'border-danger': !passed }"
                              placeholder=" "
                            />
                            <label v-bind:class="{ 'text-danger': !passed }">
                              {{ $t('global.designation') }}
                            </label>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <v-select
                            v-model="ressourcenstatus"
                            label="bezeichnung"
                            :options="ressourcenstati"
                            :reduce="(s) => s.id"
                            :placeholder="$t('global.reservationstatus')"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.reservationstatus') }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <v-select
                            v-model="planungsstatus"
                            label="bezeichnung"
                            :options="planungsstati"
                            :placeholder="$t('global.planningstatus')"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.planningstatus') }}</label>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <v-select
                            v-model="durchfuehrungsstatus"
                            label="bezeichnung"
                            :options="durchfuehrungsstati"
                            :placeholder="$t('global.executionstatus')"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.executionstatus') }}</label>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-if="!terminId"
                    >
                      <div class="col-xl-6">
                        <div class="form-radio-group">
                          <input
                            type="radio"
                            id="repeating-no"
                            value="false"
                            v-model="repeating"
                          />
                          <label
                            for="repeating-no"
                            class="ml-2"
                          >
                            {{ $t('global.onetime') }}
                          </label>

                          <input
                            type="radio"
                            id="repeating-yes"
                            value="true"
                            v-model="repeating"
                            class="ml-2"
                          />
                          <label
                            for="repeating-yes"
                            class="ml-2"
                          >
                            {{ $t('global.recurring') }}
                          </label>
                        </div>
                      </div>

                      <div
                        class="col-xl-4"
                        v-if="repeating == 'true'"
                      >
                        <div class="form-group">
                          <v-select
                            v-model="periodizitaet"
                            label="bezeichnung"
                            :options="periodizitaeten"
                            :reduce="(r) => r.id"
                            :placeholder="$t('global.periodicity')"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.periodicity') }}</label>
                        </div>
                      </div>
                      <div
                        class="col-xl-2"
                        v-if="repeating == 'true'"
                      >
                        <div class="form-group">
                          <input
                            v-model.number="repeatcount"
                            class="form-control"
                            placeholder=""
                          />
                          <label>{{ $t('global.Number') }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-3">
                        <div class="form-group">
                          <ValidationProvider
                            rules="required"
                            immediate
                          >
                            <input
                              v-model="von"
                              type="hidden"
                            />
                            <date-picker
                              date-format="dd.mm.yy"
                              :initial="localVon"
                              placeholer=""
                              :show-icon="true"
                              @update="updateVon"
                              :inModal="true"
                            />
                            <label>{{ $t('global.datstart') }}</label>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <ValidationProvider
                          rules="required"
                          immediate
                        >
                          <div class="form-group">
                            <div class="input-group">
                              <input
                                type="time"
                                class="form-control"
                                v-model="von_uhrzeit"
                              />
                              <div
                                class="input-group-append text-medium-light h-100 mr-2 d-flex align-items-center"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-clock"
                                  class="m-auto"
                                />
                              </div>
                            </div>
                            <label>{{ $t('global.starttime') }}</label>
                          </div>
                        </ValidationProvider>
                      </div>

                      <div
                        class="col-xl-3"
                        v-if="repeating == 'false'"
                      >
                        <div class="form-group">
                          <ValidationProvider
                            rules="required"
                            immediate
                          >
                            <date-picker
                              date-format="dd.mm.yy"
                              :initial="localBis"
                              placeholder=" "
                              :show-icon="true"
                              @update="updateBis"
                            />
                            <label>{{ $t('global.dateend') }}</label>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <ValidationProvider
                          rules="required"
                          immediate
                        >
                          <div class="form-group">
                            <div class="input-group">
                              <input
                                type="time"
                                class="form-control"
                                v-model="bis_uhrzeit"
                              />
                              <div
                                class="input-group-append text-medium-light h-100 mr-2 d-flex align-items-center"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-clock"
                                  class="m-auto"
                                />
                              </div>
                            </div>
                            <label>{{ $t('global.endtime') }}</label>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <input
                            v-model.number="lektionen"
                            class="form-control"
                            placeholder=""
                          />
                          <label>
                            {{ $t('global.lessons') }}
                            <!-- {{ dozent1PersonName }} -->
                          </label>
                        </div>
                      </div>
                      <div class="col-xl-6"></div>
                    </div>
                    <div class="row">
                      <!-- single select für Veranstaltung -->
                      <div class="col-xl-6">
                        <single-select-veranstaltung
                          :id="singleSelectVeranstaltungId"
                          :label="$t('global.event')"
                          :veranstaltung="gewaehlteVeranstaltung"
                          :editable="canEditAppointment"
                          @confirmed="setVeranstaltung"
                          :allowOpen="canOpenAppointment"
                        />
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <v-select
                            v-model="dozenten"
                            label="personName"
                            :options="person"
                            :placeholder="$t('global.lecturer')"
                            :reduce="(r) => r.id"
                            multiple
                            @confirmed="setVerantwortlicher"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.lecturer') }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <v-select
                            v-model="verantwortlich"
                            label="personName"
                            :options="person"
                            :placeholder="$t('global.responsible')"
                            :reduce="(r) => r.id"
                          >
                            <span slot="no-options">
                              {{ $t('notification.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.responsible') }}</label>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <single-select-person
                          id="termin-reserviert-durch"
                          :person="reserviert_durch"
                          :label="$t('global.reservedby')"
                          :allowOpen="false"
                          :rollen="filterRollenMitarbeiter"
                          :editable="true"
                          :required="true"
                          @confirmed="setReserviertDurch"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <v-select
                            v-model="ressourcenbuchung"
                            label="bezeichnung"
                            :options="ressourcenbuchungstypen"
                            :reduce="(r) => r.id"
                            :placeholder="$t('global.externalinternal')"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.resourcebooking') }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <!-- v-select für Education -->
                          <v-select
                            v-model="selectedGebaeude"
                            label="bezeichnung"
                            :options="gebaeude"
                            v-if="$CONST('CONFIG').APPTYPE === 'Education'"
                            :reduce="(r) => r.id"
                            :placeholder="$t('global.building')"
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.building') }}</label>
                        </div>
                      </div>

                      <div class="col-xl-6">
                        <div class="form-group">
                          <!-- v-select für Education -->
                          <v-select
                            v-model="selectedRaum"
                            label="bezeichnung"
                            :options="filteredRaeume"
                            v-if="$CONST('CONFIG').APPTYPE === 'Education'"
                            :reduce="(r) => r.id"
                            :placeholder="$t('global.room')"
                            multiple
                          >
                            <span slot="no-options">
                              {{ $t('global.taptosearch') }}
                            </span>
                          </v-select>
                          <label>{{ $t('global.room') }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="form-group">
                          <textarea
                            v-model.trim="bemerkung"
                            class="form-control"
                            placeholder=" "
                            rows="4"
                          ></textarea>
                          <label>{{ $t('global.comment') }}</label>
                        </div>
                      </div>
                    </div>
                    <!-- Start Beschreibung/Details -->
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="form-group">
                          <button
                            type="button"
                            class="btn btn-link p-0"
                            @click="
                              showDescriptionLecturer = !showDescriptionLecturer
                            "
                          >
                            {{ $t('global.showTermindescription_dozierende') }}
                            <span v-if="showDescriptionLecturer">▲</span>
                            <span v-else>▼</span>
                          </button>
                        </div>
                      </div>
                      <div class="col-xl-12">
                        <div
                          class="form-group"
                          v-if="showDescriptionLecturer"
                        >
                          <label>
                            {{ $t('global.termindescription_dozierende') }}
                          </label>
                          <ckeditor
                            :editor="editor"
                            v-model="descriptionLecturer"
                          ></ckeditor>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="form-group">
                          <button
                            type="button"
                            class="btn btn-link p-0"
                            @click="
                              showDescriptionStudents = !showDescriptionStudents
                            "
                          >
                            {{ $t('global.showTermindescription_students') }}
                            <span v-if="showDescriptionStudents">▲</span>
                            <span v-else>▼</span>
                          </button>
                        </div>
                      </div>
                      <div class="col-xl-12">
                        <div
                          class="form-group"
                          v-if="showDescriptionStudents"
                        >
                          <label>
                            {{ $t('global.termindescription_students') }}
                          </label>
                          <ckeditor
                            :editor="editor"
                            v-model="descriptionStudents"
                          ></ckeditor>
                        </div>
                      </div>
                    </div>
                    <!-- Ende Beschreibung/Details -->
                  </div>
                </div>
              </div>
              <!-- ENDE Stammdaten -->
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              @click="closeModal"
            >
              {{ $t('global.cancel') }}
            </button>
            <button
              type="button"
              :disabled="invalid"
              class="btn btn-primary"
              @click="speichern"
            >
              {{ $t('global.save') }}
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>
    <loading-overlay v-if="loading"></loading-overlay>

    <message-box
      id="termin-konflikt-modal-terminreiter"
      :headerText="$t('global.dateconflict')"
      :text="$t('global.aconflictwithanappointmentoccurredwhensaving')"
      :ok="true"
      :cancel="true"
      :okText="$t('global.acceptdateconflict')"
      @ok="acceptConflict"
      @cancel="setConflictStatus"
      :cancelText="$t('global.dontacceptdateconflict')"
    >
      <p v-if="currentconflicts.length !== 0">
        {{ $t('global.conflictswith') }}:
      </p>
      <div class="terminkonflikte">
        <div
          v-for="(conflict, index) of currentconflicts"
          :key="index"
        >
          <div class="row pl-2">
            <div class="col-12">
              <div
                class="terminkonfliktelement"
                v-if="conflict.raum"
                @click="openTermin(conflict.termin.id)"
                v-tooltip
                :title="$t('global.showappointment')"
              >
                <div>
                  {{ conflict.termin.von }} {{ conflict.termin.von_uhrzeit }} -
                  {{ conflict.termin.bis }} {{ conflict.termin.bis_uhrzeit }}
                </div>
                <div>
                  {{ $t('global.reason') }}: {{ $t('global.room') }}
                  {{ conflict.raum.bezeichnung }}
                </div>
              </div>
              <div
                class="terminkonfliktelement"
                v-if="conflict.dozent"
                @click="openTermin(conflict.termin.id)"
                v-tooltip
                :title="$t('global.showappointment')"
              >
                <div>
                  {{ conflict.termin.von }} {{ conflict.termin.von_uhrzeit }} -
                  {{ conflict.termin.bis }} {{ conflict.termin.bis_uhrzeit }}
                </div>
                <div>
                  {{ $t('global.reason') }}: {{ $t('global.lecturer') }}
                  {{ conflict.dozent.vorname }} {{ conflict.dozent.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </message-box>
  </div>
</template>

<script>
  import AppApi from '@/api/AppApi'
  import { apiErrorToAlert } from '@/utils/Errorhandler'
  import ContainerHeadline from '@/components/ContainerHeadline'
  import DatePicker from '@/components/Datepicker'
  import ModalCloseButton from '@/components/global/ModalCloseButton'
  import SingleSelectPerson from '@/components/global/SingleSelectPerson.vue'
  import LoadingOverlay from '@/components/global/LoadingOverlay'
  import MessageBox from '@/components/Modals/Messagebox.vue'
  import ClassicEditor from '/custom/custom_ckeditor/build/ckeditor'
  import { LADE_AUSWAHLWERTE_RESSOURCEN } from '@/store/ressourcen/actions.type'
  import SingleSelectVeranstaltung from '@/components/global/SingleSelectVeranstaltung.vue'

  export default {
    name: 'NeuerTerminModal',
    components: {
      ContainerHeadline,
      DatePicker,
      ModalCloseButton,
      SingleSelectPerson,
      LoadingOverlay,
      MessageBox,
      SingleSelectVeranstaltung,
    },
    props: {
      canOpenAppointment: {
        type: Boolean,
        default: false,
      },
      canEditAppointment: {
        type: Boolean,
        default: false,
      },
      singleSelectVeranstaltungId: {
        type: String,
        required: true,
      },
      von: {
        type: String,
        required: false,
        default: () => new Intl.DateTimeFormat('de-CH').format(new Date()),
      },
      bis: {
        type: String,
        required: false,
        default: () => new Intl.DateTimeFormat('de-CH').format(new Date()),
      },
      id: {
        type: String,
        required: true,
      },
      veranstaltung: {
        type: Object,
        required: false,
        default: null,
      },
      raum: {
        type: String,
        required: false,
        default: null,
      },
      planungsstati: {
        type: Array,
        required: true,
      },
      durchfuehrungsstati: {
        type: Array,
        required: true,
      },
      dozentenbuchungen: {
        type: Array,
        required: false,
        default: () => [],
      },
      anzahl_anmeldungen: {
        type: Number,
        required: false,
        default: 0,
      },
      call_getTermine_method: {
        type: Boolean,
        default: true,
      },
      reload_page_data_after_saving: {
        type: Boolean,
        default: false,
      },
      alternatingModalTitle: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        loading: false,
        shown: false,
        terminId: null,
        selectedGebaeude: null,
        selectedRaum: [],
        verantwortlich: null,
        verantwortlicher: { personName: this.$t('global.notlinked') },
        reserviert_durch: { personName: this.$t('global.notlinked') },
        initialPlanungsStatusID: '17574932559',
        initialDurchfuehrungsStatusID: '175748EC2CB',
        planungsstatus: null,
        durchfuehrungsstatus: null,
        bezeichnung: null,
        bis_uhrzeit: null,
        von_uhrzeit: null,
        repeating: 'false',
        infoscreen: true,
        periodizitaet: this.$CONST('PERIODIZITAETEN').WEEKLY,
        repeatcount: null,
        dozenten: [],
        bemerkung: null,
        descriptionStudents: null,
        descriptionLecturer: null,
        ressourcenbuchung: this.$CONST('RESSOURCENBUCHUNGEN').INTERNAL,
        ressourcenstatus: this.$CONST('RESSOURCENSTATI').RESERVED,
        lektionen: null,
        raumliste: null,
        filterRollenDozenten: this.$CONST('ROLLEN').DOZENTEN,
        filterRollenMitarbeiter: this.$CONST('ROLLEN').MITARBEITER,
        currentconflicts: [],
        // --- NEW: local copies for von/bis ---
        localVon: this.von,
        localBis: this.bis,
        gewaehlteVeranstaltung: { bezeichnung: this.$t('global.notlinked') },
        appointmentChanged: false,
        localDozentenbuchungen: [],
        showDescriptionLecturer: true,
        showDescriptionStudents: true,
        editor: ClassicEditor,
      }
    },
    computed: {
      appointmentNotSelected() {
        return (
          this.gewaehlteVeranstaltung &&
          Object.keys(this.gewaehlteVeranstaltung).length === 1 &&
          this.gewaehlteVeranstaltung.bezeichnung ===
            this.$t('global.notlinked')
        )
      },
      ressourcenstati: {
        get() {
          return this.$store.state.ressourcen.ressourcenstati
        },
      },
      ressourcenbuchungstypen: {
        get() {
          return this.$store.state.ressourcen.ressourcenbuchungstypen
        },
      },
      raeume: {
        get() {
          return this.$store.state.ressourcen.raeume
        },
      },
      periodizitaeten: {
        get() {
          return this.$store.state.ressourcen.periodizitaeten
        },
      },
      mitarbeiter: {
        get() {
          return this.$store.state.mitarbeiter
        },
      },
      person: function () {
        let personen = []
        if (
          !this.localDozentenbuchungen ||
          this.localDozentenbuchungen.length <= 0
        ) {
          return personen
        }
        this.localDozentenbuchungen.forEach((db) => personen.push(db.person))
        return personen
      },

      dozentenGewaehlt: function () {
        return this.findeDozentenbuchungenAufTermin(this.dozenten)
      },
      gebaeude: {
        get() {
          return this.$store.state.ressourcen.gebaeude
        },
      },
      filteredRaeume: function () {
        // Filter raeume based on the selectedGebaeude
        if (this.selectedGebaeude) {
          return this.raeume.filter(
            (raum) => raum.gebaeude?.id === this.selectedGebaeude
          )
        }
        return this.raeume // If no gebaeude is selected, show all raeume
      },
    },
    watch: {
      appointmentChanged(newVal) {
        if (this.appointmentNotSelected === false && newVal === true) {
          if (!this.gewaehlteVeranstaltung?.id) return

          AppApi.get('liste-dozentenbuchung/', {
            params: {
              veranstaltung: this.gewaehlteVeranstaltung.id,
              page: 0,
              count: 100,
            },
          })
            .then((response) => {
              this.localDozentenbuchungen = response.data
              this.appointmentChanged = false
            })
            .catch((e) => {
              this.appointmentChanged = false
              this.$notify(apiErrorToAlert(e))
            })
        }
      },
      planungsstati(newVal) {
        if (newVal.length > 0) {
          this.getInitialPlanungsStatus()
        }
      },
      durchfuehrungsstati(newVal) {
        if (newVal.length > 0) {
          this.getInitialDurchfuehrungsStatus()
        }
      },
      selectedGebaeude: function () {
        if (this.selectedRaum) {
          let filteredRaumByGebaeudeID = this.raeume.filter(
            (raum) => raum.id === this.selectedRaum[0]
          )[0]
          if (
            filteredRaumByGebaeudeID?.gebaeude?.id != this.selectedGebaeude ||
            this.selectedGebaeude == null
          ) {
            this.selectedRaum = null
          }
        }
      },
      'termin.raumliste': function () {
        this.selectedRaum = this.termin.raumliste.map((raum) => raum.id)
      },
      selectedRaum: function () {
        if (!this.selectedGebaeude && this.selectedRaum && this.raeume.length) {
          let filteredGebaeude = this.raeume.filter(
            (raum) => raum.id === this.selectedRaum[0]
          )
          this.selectedGebaeude = filteredGebaeude[0]?.gebaeude?.id
        }
      },
      dozenten(newVal) {
        if (newVal.length > 0) {
          this.verantwortlich = newVal[0]
        } else if (newVal.length == 0) {
          this.verantwortlich = null
        }
      },
    },
    mounted() {
      if (this.ressourcenstati.length == 0) {
        this.$store.dispatch(`ressourcen/${LADE_AUSWAHLWERTE_RESSOURCEN}`)
      }
      this.$bus.$on('openNeuerTerminModal:new', (id, appointment = null) => {
        if (id === this.id && !this.shown) this.openModal(id, appointment)
      })
      this.$bus.$on('openNeuerTerminModal:edit', (id, appointment = null) => {
        if (id === this.id && !this.shown) this.openModal(id, appointment)
      })
    },
    methods: {
      setVeranstaltung(veranstaltung) {
        // Andere Veranstaltung: deren Dozentenbuchungen laden und die alte Dozentenauswahl verwerfen,
        // sonst stehen Dozenten der vorherigen Veranstaltung zur Auswahl (Vergleich über die ID,
        // das Kürzel kann leer sein)
        if ((veranstaltung?.id || null) !== (this.gewaehlteVeranstaltung?.id || null)) {
          this.localDozentenbuchungen = []
          this.dozenten = []
          if (veranstaltung?.id) this.ladeDozentenbuchungen(veranstaltung.id)
        }

        this.gewaehlteVeranstaltung = veranstaltung
      },
      ladeDozentenbuchungen(veranstaltungId) {
        AppApi.get('liste-dozentenbuchung/', {
          params: { veranstaltung: veranstaltungId, page: 0, count: 100 },
        })
          .then((response) => {
            // nur übernehmen, wenn in der Zwischenzeit nicht schon wieder gewechselt wurde
            if (this.gewaehlteVeranstaltung?.id === veranstaltungId)
              this.localDozentenbuchungen = response.data
          })
          .catch((e) => this.$notify(apiErrorToAlert(e)))
      },
      getModalTitle() {
        return this.$t(
          this.alternatingModalTitle === null
            ? 'global.createnewappointment'
            : this.alternatingModalTitle
        )
      },
      getInitialPlanungsStatus() {
        this.planungsstatus = this.planungsstati.find((status) => {
          return status.id === this.initialPlanungsStatusID
        })
      },
      getInitialDurchfuehrungsStatus() {
        this.durchfuehrungsstatus = this.durchfuehrungsstati.find((status) => {
          return status.id === this.initialDurchfuehrungsStatusID
        })
      },
      updateVon(val) {
        // Eintägiger Termin: Enddatum wandert mit. Mehrtägige Termine behalten ihr Enddatum.
        if (!this.localBis || this.localBis === this.localVon) this.localBis = val
        this.localVon = val
      },
      updateBis(val) {
        this.localBis = val
      },
      openModal(id, appointment = null) {
        this.shown = true
        const thisId = id ? id : this.id
        this.terminId = appointment?.id || null
        if (this.raum) this.raumliste = [this.raum]
        if (this.veranstaltung) {
          this.gewaehlteVeranstaltung = this.veranstaltung
        }
        this.getInitialPlanungsStatus()
        this.getInitialDurchfuehrungsStatus()
        this.reserviert_durch = this.mitarbeiter.person
        this.localVon = this.von
        this.localBis = this.bis

        if (appointment) {
          this.bezeichnung = appointment.bezeichnung || ''
          this.localVon = appointment.von || this.localVon
          this.localBis = appointment.bis || this.localBis
          this.von_uhrzeit = appointment.von_uhrzeit || null
          this.bis_uhrzeit = appointment.bis_uhrzeit || null
          this.planungsstatus = appointment.planungsstatus || null
          this.durchfuehrungsstatus = appointment.durchfuehrungsstatus || null
          this.ressourcenbuchung = appointment.ressourcenbuchung || null
          this.lektionen = appointment.lektionen || null
          this.setDozentenWithCorrectNameField(appointment)
          this.bemerkung = appointment.bemerkung || null
          this.selectedGebaeude = appointment.gebaeude || null
          this.selectedRaum =
            appointment.raumliste?.map((r) => r?.id ?? r) || []
          this.verantwortlich = appointment.verantwortlich || null
          this.reserviert_durch =
            appointment.reserviert_durch || this.reserviert_durch
          this.repeating =
            appointment.repeating !== undefined
              ? String(appointment.repeating)
              : 'false'
          this.periodizitaet = appointment.periodizitaet || this.periodizitaet
          this.repeatcount = appointment.repeatcount || null
          this.infoscreen =
            appointment.infoscreen !== undefined ? appointment.infoscreen : true
          this.anzahl_anmeldungen = appointment.anzahl_anmeldungen || 0
          this.descriptionLecturer = appointment.description_lecturer || null
          this.descriptionStudents = appointment.description_students || null
          this.gewaehlteVeranstaltung = appointment.veranstaltung || {
            bezeichnung: this.$t('global.notlinked'),
          }
        }
        this.localDozentenbuchungen = this.$props.dozentenbuchungen || []

        // If no dozentenbuchungen from prop (e.g. when opened from visual planner),
        // fetch them automatically based on the selected Veranstaltung
        if (
          !this.localDozentenbuchungen.length &&
          this.gewaehlteVeranstaltung?.id
        ) {
          AppApi.get('liste-dozentenbuchung/', {
            params: {
              veranstaltung: this.gewaehlteVeranstaltung.id,
              page: 0,
              count: 100,
            },
          })
            .then((response) => {
              this.localDozentenbuchungen = response.data
            })
            .catch((e) => {
              this.$notify(apiErrorToAlert(e))
            })
        }

        // Beim Bearbeiten den vollständigen Termin laden: die Planer-Daten enthalten nicht alle Felder
        if (this.terminId) this.ladeTermin(this.terminId)

        $('#' + thisId).modal({
          backdrop: 'static',
          keyboard: false,
        })
      },
      ladeTermin(terminId) {
        this.loading = true
        AppApi.get('termin/', { params: { id: terminId } })
          .then(({ data }) => {
            if (terminId !== this.terminId) return
            this.bezeichnung = data.bezeichnung || ''
            this.localVon = data.von || this.localVon
            this.localBis = data.bis || this.localBis
            this.von_uhrzeit = data.von_uhrzeit || null
            this.bis_uhrzeit = data.bis_uhrzeit || null
            this.lektionen = data.lektionen ?? null
            this.bemerkung = data.bemerkung || null
            this.infoscreen = data.infoscreen === true
            this.ressourcenstatus = data.ressourcenstatus_id || null
            this.ressourcenbuchung = data.ressourcenbuchung_id || null
            this.planungsstatus =
              this.planungsstati.find((s) => s.id === data.planungsstatus_id) ||
              null
            this.durchfuehrungsstatus =
              this.durchfuehrungsstati.find(
                (s) => s.id === data.durchfuehrungsstatus_id
              ) || null
            this.descriptionLecturer =
              data.beschreibung_details_dozierende || null
            this.descriptionStudents =
              data.beschreibung_details_studenten || null
            this.reserviert_durch = data.reserviert_durch
              ? {
                  id: data.reserviert_durch.id,
                  personName: data.reserviert_durch.bezeichnung,
                }
              : { personName: this.$t('global.notlinked') }
            this.gewaehlteVeranstaltung = data.veranstaltung || {
              bezeichnung: this.$t('global.notlinked'),
            }
            this.selectedGebaeude = data.gebaeude_id || null
            this.dozenten = data.dozenten_ids || []
            // Raum und Verantwortlich erst nach den Watchern auf Gebäude bzw. Dozenten setzen,
            // die sonst den Raum leeren bzw. den Verantwortlichen auf den ersten Dozenten stellen
            this.$nextTick(() => {
              this.selectedRaum = data.raumliste_ids || []
              this.verantwortlich = data.verantwortlich_id || null
            })
            if (
              data.veranstaltung?.id &&
              !this.localDozentenbuchungen.length
            ) {
              return AppApi.get('liste-dozentenbuchung/', {
                params: {
                  veranstaltung: data.veranstaltung.id,
                  page: 0,
                  count: 100,
                },
              }).then((response) => {
                this.localDozentenbuchungen = response.data
              })
            }
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
          })
          .finally(() => {
            this.loading = false
          })
      },
      setDozentenWithCorrectNameField(appointment) {
        if (appointment.dozenten && Array.isArray(appointment.dozenten)) {
          this.dozenten = appointment.dozenten.map((d) => d?.id ?? d)
        } else {
          this.dozenten = []
        }
      },
      closeModal() {
        this.shown = false
        this.clearModalContent()
        $('#' + this.id).modal('hide')
      },
      clearModalContent() {
        this.terminId = null
        this.localDozentenbuchungen = []
        this.descriptionLecturer = null
        this.descriptionStudents = null
        this.currentconflicts = []
        this.selectedGebaeude = null
        this.selectedRaum = []
        this.verantwortlicher = { personName: this.$t('global.notlinked') }
        this.reserviert_durch = { personName: this.$t('global.notlinked') }
        this.initialPlanungsStatusID = '17574932559'
        this.initialDurchfuehrungsStatusID = '175748EC2CB'
        this.getInitialPlanungsStatus()
        this.getInitialDurchfuehrungsStatus()
        this.bezeichnung = null
        this.bis_uhrzeit = null
        this.von_uhrzeit = null
        this.repeating = 'false'
        this.infoscreen = true
        this.periodizitaet = this.$CONST('PERIODIZITAETEN').WEEKLY
        this.repeatcount = null
        this.dozenten = []
        this.bemerkung = null
        this.ressourcenbuchung = this.$CONST('RESSOURCENBUCHUNGEN').INTERNAL
        this.ressourcenstatus = this.$CONST('RESSOURCENSTATI').RESERVED
        this.lektionen = null
        this.raumliste = null
        // --- NEW: reset localVon/localBis to default values ---
        this.localVon = this.von
        this.localBis = this.bis
        this.gewaehlteVeranstaltung = {
          bezeichnung: this.$t('global.notlinked'),
        }
      },
      setVerantwortlicher(dozenten) {
        this.dozenten = this.findeDozentenbuchungenAufTermin(this.dozenten)
      },

      setReserviertDurch(person) {
        this.reserviert_durch = person
      },
      findeDozentenbuchungenAufTermin(dozenten) {
        let dozentenbuchungenAufTermin = []

        if (
          !this.localDozentenbuchungen ||
          this.localDozentenbuchungen.length <= 0
        ) {
          return
        }
        dozenten.forEach((doz) => {
          let db = this.localDozentenbuchungen.find((e) => {
            return e.person.id === doz
          })
          dozentenbuchungenAufTermin.push(db)
        })

        return dozentenbuchungenAufTermin
      },

      ueperfpruefeRaumKonflikte(data) {
        return (data?.konflikte?.length || 0) > 0
      },

      speichern() {
        if (this.loading) return
        this.loading = true
        const istBearbeiten = !!this.terminId
        // null = Dozentenbuchungen nicht geladen, Dozenteneinsätze bleiben unverändert
        const dozentenbuchungen = this.dozentenGewaehlt
        const json = {
          veranstaltungId:
            this.gewaehlteVeranstaltung?.id || this.veranstaltung?.id || null,
          ressourcenstatusId: this.ressourcenstatus || null,
          planungsstatusId:
            this.planungsstatus?.id ?? this.planungsstatus ?? null,
          durchfuehrungsstatusId:
            this.durchfuehrungsstatus?.id ?? this.durchfuehrungsstatus ?? null,
          bezeichnung: this.bezeichnung,
          von: this.localVon,
          vonUhrzeit: this.von_uhrzeit,
          bis: this.localBis,
          bisUhrzeit: this.bis_uhrzeit,
          bemerkung: this.bemerkung,
          infoscreen: this.infoscreen,
          reserviertDurchId: this.reserviert_durch?.id || null,
          verantwortlichId: this.verantwortlich || null,
          ressourcenbuchungId: this.ressourcenbuchung || null,
          lektionen: this.lektionen,
          dozentenbuchungIds: dozentenbuchungen
            ? dozentenbuchungen.filter((db) => db?.id).map((db) => db.id)
            : null,
          repeating: !istBearbeiten && this.repeating !== 'false',
          periodizitaetId: this.periodizitaet,
          repeatCount: this.repeatcount == null ? 1 : this.repeatcount,
          anzahlAnmeldungen: this.anzahl_anmeldungen,
          beschreibungDetailsStudenten: this.descriptionStudents,
          beschreibungDetailsDozierende: this.descriptionLecturer,
          gebaeudeId: this.selectedGebaeude || null,
          raumlisteIds: this.selectedRaum || [],
        }
        const request = istBearbeiten
          ? AppApi.put('termin/', json, { params: { id: this.terminId } })
          : AppApi.post('termin/', json)
        request
          .then((response) => {
            if (!this.ueperfpruefeRaumKonflikte(response.data)) {
              this.$notify({
                type: 'success',
                title: this.$t('global.actionsuccessful'),
                text: istBearbeiten
                  ? null
                  : this.$t('global.appointmentsuccessfullycreated'),
              })
            } else {
              this.$notify({
                type: 'warn',
                title: this.$t('global.actionsuccessful'),
                text: this.$t('global.roomisalreadyreserved'),
              })
              this.currentconflicts = response.data.konflikte
            }
            this.call_getTermine_method ? this.$parent.getTermine() : null
            this.reload_page_data_after_saving
              ? this.$parent.reloadPageData()
              : null
            this.loading = false
            this.closeModal()
          })
          .catch((e) => {
            // Modal bleibt offen, damit die Eingaben nicht verloren gehen
            this.loading = false
            this.$notify(apiErrorToAlert(e))
          })
      },

      acceptConflict() {},
      setConflictStatus() {},

      openTermin(terminId) {
        // open termin in new tab
        const url = this.$router.resolve({
          name: 'termin',
          params: { id: terminId, anzeige: 0 },
        }).href
        window.open(url, '_blank')
      },

      collectIds(response) {
        // get ID from single Terminresponse
        const collectIds = []
        response?.termine.forEach((terminId) => {
          collectIds.push(terminId)
        })

        if (response?.termin?.id) collectIds.push(response?.termin?.id)

        return collectIds
      },
    },
  }
</script>

<style></style>
